import BaseUseCase from "../../../base_use_case.js";
import Routes from "../../../../admin/routes.js";
class ListDevelopersUseCase extends BaseUseCase {

  execute(params) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/admin/projects/developers`,
      params: params
    }).then((result) => {
      let { data, headers } = result; 
      let { developers } = data; 

      developers = developers.map((developer) => {
        return {
          ...developer,
          key: developer.id,
          itemLink: Routes.developer(developer)
        }
      })
      data.list = developers;
      return {
        data: data,
        headers: headers
      }
    })
  }
}

const instance = new ListDevelopersUseCase();
export default instance;